import { Header } from '../components/Header'
import { Footer } from '../components/Footer'

export const GDPR: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Informacja RODO</h1>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Informacja o przetwarzaniu danych osobowych</h2>
              <p className="text-gray-600 mb-4">
                Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
                (RODO), informujemy o przetwarzaniu Państwa danych osobowych.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Administrator danych osobowych</h2>
              <div className="bg-gray-50 p-6 rounded-lg mb-4">
                <p className="text-gray-800 font-medium mb-2">AI SOFTWARE SYSTEMS sp. z o.o.</p>
                <p className="text-gray-600 text-sm">
                  Kontakt: poprzez formularz kontaktowy dostępny na stronie /contact
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Cele przetwarzania danych</h2>
              <div className="space-y-4">
                <div className="border-l-4 border-blue-500 pl-4">
                  <h3 className="font-semibold text-gray-800">Świadczenie usług generatora domen</h3>
                  <p className="text-gray-600">Podstawa prawna: art. 6 ust. 1 lit. b RODO (wykonanie umowy)</p>
                  <p className="text-gray-600 text-sm">Okres przechowywania: do zakończenia świadczenia usługi</p>
                </div>

                <div className="border-l-4 border-green-500 pl-4">
                  <h3 className="font-semibold text-gray-800">Marketing bezpośredni naszych usług</h3>
                  <p className="text-gray-600">Podstawa prawna: art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes)</p>
                  <p className="text-gray-600 text-sm">Okres przechowywania: do wniesienia skutecznego sprzeciwu</p>
                </div>

                <div className="border-l-4 border-purple-500 pl-4">
                  <h3 className="font-semibold text-gray-800">Analiza ruchu i optymalizacja serwisu</h3>
                  <p className="text-gray-600">Podstawa prawna: art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes)</p>
                  <p className="text-gray-600 text-sm">Okres przechowywania: 26 miesięcy</p>
                </div>

                <div className="border-l-4 border-orange-500 pl-4">
                  <h3 className="font-semibold text-gray-800">Rozliczenia i księgowość</h3>
                  <p className="text-gray-600">Podstawa prawna: art. 6 ust. 1 lit. c RODO (obowiązek prawny)</p>
                  <p className="text-gray-600 text-sm">Okres przechowywania: 5 lat od końca roku podatkowego</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Kategorie przetwarzanych danych</h2>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <li className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-blue-800 mb-2">Dane identyfikacyjne</h4>
                  <ul className="text-sm text-blue-700 space-y-1">
                    <li>• Imię i nazwisko</li>
                    <li>• Adres e-mail</li>
                    <li>• Numer telefonu (opcjonalnie)</li>
                  </ul>
                </li>
                <li className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-green-800 mb-2">Dane techniczne</h4>
                  <ul className="text-sm text-green-700 space-y-1">
                    <li>• Adres IP</li>
                    <li>• Typ przeglądarki</li>
                    <li>• System operacyjny</li>
                  </ul>
                </li>
                <li className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-purple-800 mb-2">Dane behawioralne</h4>
                  <ul className="text-sm text-purple-700 space-y-1">
                    <li>• Historia zapytań</li>
                    <li>• Czas korzystania</li>
                    <li>• Preferencje użytkownika</li>
                  </ul>
                </li>
                <li className="bg-orange-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-orange-800 mb-2">Dane płatnicze</h4>
                  <ul className="text-sm text-orange-700 space-y-1">
                    <li>• Dane faktury</li>
                    <li>• Historia płatności</li>
                    <li>• Metody płatności</li>
                  </ul>
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Prawa przysługujące osobom, których dane dotyczą</h2>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                <h3 className="font-semibold text-yellow-800 mb-4">Przysługują Pani/Panu następujące prawa:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  <div>
                    <h4 className="font-semibold text-yellow-800">Prawo dostępu (art. 15 RODO)</h4>
                    <p className="text-yellow-700">Prawo uzyskania informacji o przetwarzanych danych</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-yellow-800">Prawo sprostowania (art. 16 RODO)</h4>
                    <p className="text-yellow-700">Prawo do poprawienia nieprawdziwych danych</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-yellow-800">Prawo do usunięcia (art. 17 RODO)</h4>
                    <p className="text-yellow-700">Prawo żądania usunięcia danych w określonych przypadkach</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-yellow-800">Prawo do ograniczenia (art. 18 RODO)</h4>
                    <p className="text-yellow-700">Prawo ograniczenia przetwarzania w określonych przypadkach</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-yellow-800">Prawo do przenoszenia (art. 20 RODO)</h4>
                    <p className="text-yellow-700">Prawo otrzymania danych w formacie ustrukturyzowanym</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-yellow-800">Prawo sprzeciwu (art. 21 RODO)</h4>
                    <p className="text-yellow-700">Prawo wniesienia sprzeciwu wobec przetwarzania</p>
                  </div>
                </div>
                <div className="mt-4 p-4 bg-yellow-100 rounded">
                  <p className="text-sm text-yellow-800">
                    <strong>Aby skorzystać ze swoich praw</strong>, prosimy o kontakt poprzez formularz kontaktowy
                    lub pisemnie na adres siedziby administratora.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Prawo wniesienia skargi</h2>
              <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                <p className="text-red-800 mb-4">
                  Przysługuje Pani/Panu prawo wniesienia skargi do organu nadzorczego:
                </p>
                <div className="bg-white p-4 rounded border border-red-200">
                  <h4 className="font-semibold text-red-800 mb-2">Urząd Ochrony Danych Osobowych</h4>
                  <p className="text-red-700 text-sm">ul. Stawki 2, 00-193 Warszawa</p>
                  <p className="text-red-700 text-sm">Tel.: 22 531 03 00</p>
                  <p className="text-red-700 text-sm">E-mail: kancelaria@uodo.gov.pl</p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Źródło danych osobowych</h2>
              <p className="text-gray-600 mb-4">
                Dane osobowe pozyskiwane są bezpośrednio od osoby, której dotyczą:
              </p>
              <ul className="list-disc list-inside text-gray-600 mb-4 space-y-2">
                <li>Poprzez formularz rejestracji w serwisie</li>
                <li>Poprzez formularz kontaktowy</li>
                <li>W trakcie procesu zakupu usług premium</li>
                <li>Automatycznie w trakcie korzystania z serwisu (dane techniczne)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Transfer danych do państw trzecich</h2>
              <p className="text-gray-600 mb-4">
                W niektórych przypadkach Państwa dane mogą być przekazywane do dostawców usług
                w Stanach Zjednoczonych (Google Analytics, systemy płatnicze) na podstawie
                Decyzji adequacyjnej lub standardowych klauzul umownych zatwierdzonych przez Komisję Europejską.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Zautomatyzowane podejmowanie decyzji</h2>
              <p className="text-gray-600 mb-4">
                Serwis wykorzystuje systemy AI do generowania propozycji nazw domen.
                Proces ten nie ma charakteru profilowania ani nie wywiera prawnych skutków wobec użytkownika.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}